import styled, { css } from 'styled-components';

import { colours } from 'themes/default';

export const SidebarOverlay = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  flex: 1;
  z-index: 101;
  background-color: rgba(0, 0, 0, 0.7);

  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          opacity: 1;
          transition: visibility 0s linear 0s, opacity 1s;
        `
      : css`
          visibility: hidden;
          opacity: 0;
          transition: visibility 0s linear 500ms, opacity 500ms;
        `};
`;

export const SidebarContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 102;
  max-width: 625px;
  width: 100%;
  height: 100%;
  background-color: ${colours.Greyscale.White};

  ${({ isLeftSide }) =>
    isLeftSide
      ? css`
          left: 0;
        `
      : css`
          right: 0;
        `};

  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          transform: translateX(0);
          transition: visibility 0s linear 0s, transform 1s;
        `
      : css`
          visibility: hidden;
          transform: ${({ isLeftSide }) => (isLeftSide ? 'translateX(-100%)' : 'translateX(100%)')};
          transition: visibility 0s linear 500ms, transform 500ms;
        `};
`;
